export default __webpack_public_path__ + "static/media/86t.9ce4a321.jpg";